<template>
  <div class="flex bg-f3f4f7" style="height: 525px;">
    <div id="dialogLeft" class="h-100 flex-column bg-ff" style="width: 200px">
      <div class="left-top">
        <div class="flex-1 font-16-30313a">供应商分类</div>
      </div>
      <div class="flex-1 h-0" v-if="supplierClassifyList && supplierClassifyList.length">
        <cate-menu :not-operate="true" :menu-data="supplierClassifyList" @on-choose="onClickSupplierClassify"
          :choose-id="choseSupplierClassifyId"></cate-menu>
      </div>
    </div>
    <move-horizon move-id="dialogLeft"></move-horizon>
    <div class="flex-1 w-0 h-100 flex-column ptb-10 pr-20">
      <div class="flex content-top mb-10">
        <div class="flex-1 bg-ff h-100 flex align-center pl-5 mr-10">
          <div class="tab-item active">
            <span class="bg-4-46b8b0"></span>
            {{ currentSupplierClassify.name }}
          </div>
        </div>
        <div class="flex ml-10">
          <div class="flex align-center bg-ff h-30 border-e2 border-ra mr-10">
            <img src="/static/images/sousuo.png" class="icon-14 ml-10 mr-5" alt="">
            <input class="border-none" type="text" placeholder="供应商名称/电话" v-model="keywordsS" clearable
              @keyup.enter.native="searchSupplier">
          </div>
          <button class="btn-30-bg-46b8b0" @click="searchSupplier">搜索</button>
        </div>
      </div>
      <div class="flex-1 mb-10">
        <div class="h-100">
          <erp-table ref="supplierTable" :table-data="supplierList" :column-data="supplierColumn"
            @on-choose="onClickSupplier"></erp-table>
        </div>
      </div>
      <Pagination :pageSize="pageSize" v-model="pageNo" :pageTotal="pageTotal" :total="total" @on-jump="jump">
      </Pagination>
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import MoveHorizon from '@/components/MoveHorizon'
import CateMenu from '@/components/CateMenu'
import ErpTable from '@/components/ErpTable'
export default {
  name: 'ChooseSupplier',
  components: { Pagination, MoveHorizon, CateMenu, ErpTable },
  data () {
    return {
      keywordsS: '',
      page: 1,
      limit: 25,
      pageSize: 0, // 总页数
      pageNo: 1, // 当前页数
      pageTotal: 25, // 当前页条数
      total: 0, // 总条数
      supplierClassifyList: [],
      supplierList: [],
      currentSupplierClassify: {},
      currentSupplier: {},
      choseSupplierClassifyId: 0,
      supplierColumn: [
        {
          field: 'operate',
          title: '操作',
          width: '65',
          isDefine: true,
          child: [{
            type: 'btn',
            className: 'btn-16-color-46b8b0 btn-hover-46b8b0',
            title: '选择',
            methodName: 'on-choose'
          }]
        }, {
          field: 'name',
          title: '供应商名称',
          minWidth: '150'
        }, {
          field: 'address',
          title: '联系地址',
          minWidth: '200'
        }, {
          field: 'contact',
          title: '联系人',
          width: '100'
        }, {
          field: 'contactTelephone',
          title: '联系电话',
          width: '200'
        }
      ]
    }
  },
  created () {
    this.axios.post('businessClassify/findAll', { companyId: this.$store.state.companyId }).then(res => {
      if (res.data.success) {
        this.supplierClassifyList = res.data.data
        if (res.data.data.length > 0) {
          this.currentSupplierClassify = res.data.data[0]
          this.choseSupplierClassifyId = res.data.data[0].id
          this.getSupplier()
        }
      } else {
        this.$message({
          message: res.data.msg,
          type: 'error',
          offset: 400
        })
      }
    })
  },
  mounted () { },
  methods: {
    jump (page) {
      this.page = page.pageNo
      this.limit = page.pageTotal
      this.getSupplier()
    },
    searchSupplier () {
      this.page = 1
      this.getSupplier()
    },
    onClickSupplier (row) {
      this.$emit('click-supplier', row)
    },
    getSupplier () {
      let params = {
        page: this.page,
        limit: this.limit,
        keywords: this.keywordsS,
        companyId: this.$store.state.companyId
      }
      if (!this.keywordsS) {
        params.classifyId = this.choseSupplierClassifyId
      }
      this.axios.post('business/queryForPage', params).then(res => {
        if (res.data.success) {
          this.supplierList = res.data.data.list
          this.pageSize = res.data.data.pages
          this.pageNo = this.page
          this.pageTotal = res.data.data.size
          this.total = res.data.data.total
        }
      })
    },
    onClickSupplierClassify (menu) {
      this.currentSupplierClassify = menu
      this.choseSupplierClassifyId = menu.id
      this.page = 1
      this.getSupplier()
    }
  }
}
</script>

<style lang="scss" scoped>
.left-top {
  display: flex;
  align-items: center;
  padding: 0 10px 0 20px;
  border-bottom: 1px solid #e2e2e2;
  height: 40px;
  text-align: left;
  cursor: pointer;
}

.content-top {
  height: 30px;

  .tab-item {
    font-size: 16px;
    color: #272727;
    display: flex;
    align-items: center;
    margin-right: 15px;
    cursor: pointer;

    span {
      height: 16px;
    }

    &.active {
      color: #46b8b0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ChooseSupplier.vue